<template>
  <vx-card no-shadow>

    <div class="vx-card__title mb-8"> 
        <p>POR FAVOR LLENAR EL FORMULARIO PARA CAMBIAR SU CONTRASEÑA.</p> 
    </div> 
 
    <vs-input 
    type="password" 
    data-vv-validate-on="blur" 
    v-validate="'required'" 
    name="old_password" 
    data-vv-as="Contraseña Anterior"
    label-placeholder="Password" 
    placeholder="CONTRASEÑA ANTERIOR" 
    v-model="old_password" 
    class="w-full mb-6" /> 
    <span class="text-danger text-sm">{{ errors.first('old_password') }}</span> 
 
    <vs-input 
    ref="password" 
    type="password" 
    data-vv-validate-on="blur" 
    v-validate="'required'" 
    name="password" 
    data-vv-as="Contraseña"
    label-placeholder="Password" 
    placeholder="NUEVA CONTRASEÑA" 
    v-model="password" 
    class="w-full mb-6" /> 
    <span class="text-danger text-sm">{{ errors.first('password') }}</span> 
 
    <vs-input 
    type="password" 
    v-validate="'confirmed:password'" 
    data-vv-validate-on="blur" 
    data-vv-as="Contraseña" 
    name="confirm_password"
    label-placeholder="Confirm Password" 
    placeholder="CONFIRMAR CONTRASEÑA" 
    v-model="confirm_password" 
    class="w-full mb-8" /> 
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="w-full sm:w-auto" @click="changePassword" :disabled="!validateForm">GUARDAR</vs-button> 
      <!-- <vs-button class="ml-auto mt-2">Save Changes</vs-button> --> 
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> --> 
    </div>
  </vx-card>
</template>

<script>

import axios from "axios"; 
import auth from '@/auth/authService' 
 
var user = []; 
var token = auth.getToken(); 

export default {
  data () {
    return {
      old_password: '',
      password: '', 
      confirm_password: '' 
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }, 
    validateForm () { 
      return !this.errors.any() && this.old_password !== '' && this.password !== '' && this.confirm_password !== ''; 
    } 
  },
  methods: {
changePassword () { 
 
 
        axios.put('' + auth.connectionFrontEnd() + '/webapi/updatePasswordClientEC', 
        { 
            codemp: user.comp, 
            rucced: user.user, 
            clipswOld: this.old_password,
            clipsw: this.password 
        },  
         
        { headers: { token: token } } 
 
        ).then(response => { 
 
            if(response.data.success == true){ 
                this.password= ''; 
                this.confirm_password= ''; 
                this.$vs.notify({ 
                      title: 'Contraseña Guardada', 
                      text: 'Contraseña Guardada correctamente', 
                      iconPack: 'feather', 
                      icon: 'icon-save', 
                      color: 'success' 
                });  
                localStorage.clear(); 
                sessionStorage.clear(); 
                this.$router.push({  
                  name: "page-login"  
                }); 
            } else{ 
                this.$vs.notify({ 
                  title: 'Error Contraseña Anterior', 
                  text: 'Error Contraseña Anterior Incorrecta, Intente de nuevo', 
                  iconPack: 'feather', 
                  icon: 'icon-alert-circle', 
                  color: 'danger' 
                })  
                  }    
 
 
              }).catch(e => { 
                this.$vs.notify({ 
                    title: 'Error', 
                    text: 'Problema con el Servidor, Intente más tarde', 
                    iconPack: 'feather', 
                    icon: 'icon-alert-circle', 
                    color: 'danger' 
                  }) 
                
              }) 
 

 
    }, 
  }, 
  created () { 
      user.comp = localStorage.getItem("codemp"); 
      user.user = localStorage.getItem("rucced"); 
  }, 
}
</script>
